import {PaginationDto} from "../../common/dto/PaginationDto";

export class PersonSearchCondition extends PaginationDto {
  staffNo: string = '';
  name: string = '';
  badgeNo: string = '';
}
